import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, TicketViewModel, TicketStatusId } from '../../../models';
import { Paginator } from '../../models/alarms/alarmsGlobalTable/paginator';
import { IExportToCsvService } from '../../../services';
import { buildTable } from './buildTable';

class AuditReportStateController implements angular.IComponentController {
    beginDate: string;
    // All visible tickets after pagination.
    displayedTickets: TicketViewModel[];
    endDate: string;
    // All tickets pertaining to given date range.
    filteredTickets: TicketViewModel[];
    isLoading: boolean;
    paginator = new Paginator<TicketViewModel>();
    // All tickets received from parent controller.
    tickets: TicketViewModel[];

    static $inject = ['exportToCsvService'];

    constructor(private _exportToCsvService: IExportToCsvService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if ((changesObj['beginDate'] || changesObj['endDate'] || changesObj['tickets'])
            && this.beginDate && this.endDate && this.tickets) {
            const beginMoment = moment(this.beginDate);
            const endMoment = moment(this.endDate);
            this.filteredTickets = this.tickets
                .filter(t => {
                    const creationMoment = moment(t.model.creationDate);
                    let isInRange: boolean = creationMoment.isBefore(endMoment);
                    const isClosed = t.model.statusId === TicketStatusId.Closed;
                    if (isClosed && !isInRange) {
                        const closeDate = t.model.closedDate;
                        if (closeDate) {
                            const closedMoment = moment(closeDate);
                            isInRange = closedMoment.isAfter(beginMoment);
                        }
                    }
                    return isInRange;
                })
                .sort((a, b) => a.model.id > b.model.id ? 1 : -1);
            this.displayedTickets = this.paginator.items(this.filteredTickets)
                .paginate();
        }
    }

    more() {
        this.displayedTickets = this.paginator.more();
    }

    less() {
        this.displayedTickets = this.paginator.less();
    }

    exportToCsv() {
        const { headings, body } = buildTable(this.filteredTickets);
        const dataTable: string[][] = [headings.map(h => `"${h.label}"`)]
            .concat(body.map(b => b.map(c => {
                if (c.isUserName) {
                    return `"${c.content.displayName}"`;
                } else {
                    return `"${c.content}"`;
                }
            })));
        this._exportToCsvService.getCsvFromData(dataTable, `Audit_report_${moment(this.beginDate).format('YYYYMMDD')}_${moment(this.endDate).format('YYYYMMDD')}.csv`);

    }
}

export const wtAuditReportState: ComponentDefinition = {
    componentId: 'wtAuditReportState',
    controller: AuditReportStateController,
    template: require('./auditReportState.component.html'),
    controllerAs: 'vm',
    bindings: {
        beginDate: '<',
        endDate: '<',
        isLoading: '<',
        tickets: '<',
    }
};